import { useCallback } from 'react';

import { getStaticAssetUrl } from '@change-corgi/core/assets';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

export function useGetStaticAssetUrl(): (pathname: string) => string {
	const { environment } = useUtilityContext();
	const apiSubEnv = environment.getApiSubEnvironment();
	const demoEnvTarget = environment.getApiDemoEnvironmentTarget();
	return useCallback(
		(pathname: string) => getStaticAssetUrl(apiSubEnv, pathname, demoEnvTarget),
		[apiSubEnv, demoEnvTarget],
	);
}

export function useStaticAssetUrl(pathname: string): string {
	return useGetStaticAssetUrl()(pathname);
}
